import axios from 'axios'
import * as waxjs from "@waxio/waxjs/dist";
import Link from 'anchor-link'
import store from '@/store';
import {
    useToast
} from 'vue-toastification'
const toast = useToast()
import {
    isWebUri
} from 'valid-url';
import moment from 'moment';
import BrowserTransport from 'anchor-link-browser-transport'
var keys = null
var laccount = null
if (localStorage.getItem("ual-wax:autologin") != null) {
    let ualWax = JSON.parse(localStorage.getItem("ual-wax:autologin"))
    keys = ualWax ? ualWax.pubKeys : null
}
if (localStorage.getItem("wax_user") != null) {
    laccount = localStorage.getItem("wax_user")
}
var chainUrl = process.env.VUE_APP_CHAIN_API;
var atomicAssetUrl = process.env.VUE_APP_API_ATOMICASSETS_URL;
var assetUrl = atomicAssetUrl + "assets";
var chainDomain = process.env.VUE_APP_CHAIN_FULL_URL;
const setRPCUrl = () => {
    var rpcName = localStorage.getItem("rpc");
    if (localStorage.getItem("rpc") != null) {
        if (rpcName == "EOS Rio") {
            chainDomain = `https://wax.eosrio.io`;
            chainUrl = `https://wax.eosrio.io/v1/chain`;
            atomicAssetUrl = `https://atomic.wax.eosrio.io/atomicassets/v1/`;
            assetUrl = atomicAssetUrl + "assets";
        } else if (rpcName == "pink.gg") {
            chainDomain = `https://wax.pink.gg`;
            chainUrl = `https://wax.pink.gg/v1/chain`;
            atomicAssetUrl = `https://wax-aa.eosdac.io/atomicassets/v1/`;
            assetUrl = atomicAssetUrl + "assets";
        } else if (rpcName == "greymass") {
            chainDomain = `https://wax.greymass.com`;
            chainUrl = `https://wax.greymass.com/v1/chain`;
            atomicAssetUrl = `https://wax.api.atomicassets.io/atomicassets/v1/`;
            assetUrl = atomicAssetUrl + "assets";
        } else if (rpcName == "nation.wax") {
            chainDomain = `https://wax.api.eosnation.io`;
            chainUrl = `https://wax.api.eosnation.io/v1/chain`;
            atomicAssetUrl = `https://wax.api.atomicassets.io/atomicassets/v1/`;
            assetUrl = atomicAssetUrl + "assets";
        } else if (rpcName == "eosriobrazil") {
            chainDomain = `https://wax.eosrio.io`;
            chainUrl = `https://wax.eosrio.io/v1/chain`;
            atomicAssetUrl = `https://atomic.wax.eosrio.io/atomicassets/v1/`;
            assetUrl = atomicAssetUrl + "assets";
        } else if (rpcName == "eosdacserver") {
            chainDomain = `https://wax.eosdac.io`;
            chainUrl = `https://wax.eosdac.io/v1/chain`;
            atomicAssetUrl = `https://wax-aa.eosdac.io/atomicassets/v1/`;
            assetUrl = atomicAssetUrl + "assets";
        } else if (rpcName == "test") {
            chainDomain = `https://wax-testnet.cryptolions.io`;
            chainUrl = `https://wax-testnet.cryptolions.io/v1/chain`;
            atomicAssetUrl = `https://test.wax.api.atomicassets.io/atomicassets/v1/`;
            assetUrl = atomicAssetUrl + "assets";
        }
    }
}
setRPCUrl();
const waxOptions = {
    rpcEndpoint: chainDomain,
    userAccount: localStorage.getItem("wax_user") || null,
    pubKeys: keys,
    tryAutoLogin: false
}
var wax = new waxjs.WaxJS(waxOptions);
const getWalletBalance = async (callBack) => {
    return await axios
        .post(`${chainUrl}/get_currency_balance`, {
            account: localStorage.getItem("wax_user"),
            code: process.env.VUE_APP_TOKEN_CONTRACT,
        }).then(callBack)
}
const getImgUrl = (hash, isVideo) => {
    if (isWebUri(hash)) {
        return hash;
    }
    let url = 'http://ipfs.io/ipfs/' + hash;
    if (isVideo) {
        return url
    }
    return '//images.weserv.nl/?url=' + url + "&w=400&h=400";
}
const callApi = async (params, callback) => {
    axios
        .get(`${assetUrl}?owner=${localStorage.getItem('wax_user')}&page=1&limit=100${params}`)
        .then(callback)
}
const link = new Link({
    transport: new BrowserTransport({
        requestStatus: false
    }),
    chains: [{
        chainId: process.env.VUE_APP_CHAIN_ID,
        nodeUrl: chainDomain,
    }],
})
const callApiBySchema = async (params, callback) => {
    return await axios
        .get(`${atomicAssetUrl}templates?page=1&limit=100&${params}`)
        .then(callback)
}
const assetTransfer = async (dataParams, onSuccess, onErrorCallback) => {
    laccount = localStorage.getItem("wax_user");
    try {
        const actionData = {
            account: "atomicassets",
            name: 'transfer',
            authorization: [{
                actor: laccount,
                permission: 'active',
            }],
            data: dataParams,
        }
        if (localStorage.getItem("ual-session-authenticator") != "Wax") {
            return await doSign(actionData, onSuccess, onErrorCallback)
        } else {
            return await signWithWax({
                actions: [actionData]
            }, onSuccess, onErrorCallback)
        }
    } catch (err) {
        return onErrorCallback(err)
    }
}
const transaction = async (dataParams, onSuccessCallback) => {
    laccount = localStorage.getItem("wax_user");
    try {
        const actionData = {
            account: dataParams.contract,
            name: dataParams.action,
            authorization: [{
                actor: laccount,
                permission: 'active',
            }],
            data: dataParams.data,
        }
        if (localStorage.getItem("ual-session-authenticator") != "Wax") {
            return await doSign(actionData, onSuccessCallback, (error) => {
                error = errorFormat(error);
                toast.error(error);
            })
        } else {
            return await signWithWax({
                actions: [actionData]
            }, onSuccessCallback, (error) => {
                error = errorFormat(error);
                toast.error(error);
            })
        }
    } catch (err) {
        let error = errorFormat(err);
        toast.error(error);
    }
}
const getById = async (id, callback, onError) => {
    return await axios
        .get(`${process.env.VUE_APP_API_ASSET_URL}/${id}`)
        .then(res => res.data.data)
        .then(callback)
        .catch(onError);
}
const getTable = async (table, username = null, callBack, onError) => {
    return await wax.rpc.get_table_rows({
        scope: process.env.VUE_APP_CONTRACT,
        code: process.env.VUE_APP_CONTRACT,
        index_position: 1,
        json: true,
        limit: 10000,
        table: table,
        lower_bound: username,
        upper_bound: username
    }).then(async (res) => {
        if (res.rows.length > 0) {
            return res;
        }
        return [];
    }).then((res) => callBack(res)).catch(onError)
}
const getConfig = async (callBack, onError) => {
    return await wax.rpc.get_table_rows({
        scope: process.env.VUE_APP_CONTRACT,
        code: process.env.VUE_APP_CONTRACT,
        index_position: 1,
        json: true,
        limit: 10000,
        table: "config",
        lower_bound: null,
        upper_bound: null
    }).then(async (res) => {
        if (res.rows.length > 0) {
            return res.rows;
        }
        return [];
    }).then((res) => callBack(res)).catch(onError)
}
const getCurrentGames = async (onSuccess) => {
    return await getTable("gameplay", localStorage.getItem("wax_user"), async (result) => {
            if (result) {
                if (result.length > 0 || result.rows) {
                    return onSuccess(result.rows[0]);
                }
            }
        },
        (error) => {
            toast.error(errorFormat(error));
            return error;
        })
}
const getInventory = async (onSuccess) => {
    return await getTable(process.env.VUE_APP_TBL_INV, localStorage.getItem("wax_user"), async (result) => {
            if (result) {
                if (result.length > 0 || result.rows) {
                    return onSuccess(result.rows[0].inventory);
                }
            }
        },
        (error) => {
            toast.error(errorFormat(error));
            return error;
        })
}

const doSign = async (action, onSuccessCallback, onErrorCallback) => {
    await link.restoreSession(process.env.VUE_APP_NAME).then((session) => {
        session.transact({
            actions: [action]
        }, {
            blocksBehind: 1,
            expireSeconds: 120,
        }).then(async (res) => {
            verifyTrans(res, onSuccessCallback);
        }).catch(onErrorCallback)
    }).catch(async (error) => {
        console.log(error);
        const identity = await link.login(process.env.VUE_APP_NAME)
        const {
            session
        } = identity
        session.transact({
            actions: [action]
        }, {
            blocksBehind: 1,
            expireSeconds: 120,
        }).then(async (res) => {
            verifyTrans(res, onSuccessCallback);
        }).catch(onErrorCallback)
        return error;
    })
}
const verifyTrans = async (res, onSuccessCallback) => {
    // let status = true;
    setTimeout(async () => {
        onSuccessCallback(res);
    }, 2000);
}
const signWithWax = async (action, onSuccessCallback, onErrorCallback) => {
    laccount = localStorage.getItem("wax_user");
    let isAutoLoginAvailable = await wax.isAutoLoginAvailable();
    if (!isAutoLoginAvailable) {
        await wax.login();
    }
    try {
        await wax.api.transact(action, {
            blocksBehind: 3,
            expireSeconds: 120,
            broadcast: true,
            sign: true,
        }).then(async (res) => {
            verifyTrans(res, onSuccessCallback);
        }).catch(onErrorCallback)
    } catch (error) {
        return onErrorCallback(error)
    }
}
const isLogin = () => {
    // check local store and also expiry of session
    if (localStorage.getItem('wax_user')) {
        var sessionDate = localStorage.getItem("ual-session-expiration");
        var d1 = new Date();
        var d2 = new Date(sessionDate);
        return moment(d2).isAfter(moment(d1))
    } else {
        return false
    }
}
const isExpired = (lastDate) => {
        let d = moment.utc(lastDate).format('YYYY-MM-DDTHH:mm:ss.SSSS');
        let currentUtc = moment.utc(new Date()).format('YYYY-MM-DDTHH:mm:ss.SSSS');

        return moment(d).isAfter(currentUtc);
}

const errorFormat = (error) => {
    console.log(error.message, typeof error);
    if (typeof error == "string") {
        return error;
    }
    if (!error.error && error.message) {
        return error.message
    }
    if (error.error.what) {
        if (error.error.details) {
            return error.error.details[0].message
        }
        return error.error.what;
    } else {
        return "Transaction failed,try again."
    }
}
const successMsg = (msg) => {
    if (msg) {
        toast.success(msg);
    } else {
        toast.success("Transaction successfull");
    }
}
const errorMsg = (error) => {
    if (error) {
        toast.error(errorFormat(error));
    } else {
        toast.error("Something went wrong.transaction failed.");
    }
}

const getInGameBalance = async (callBack) => {
    return await wax.rpc.get_table_rows({
        scope: localStorage.getItem("wax_user"),
        code: process.env.VUE_APP_CONTRACT,
        index_position: 1,
        json: true,
        limit: 1,
        table: "user.balance",
        lower_bound: null
    }).then((res) => callBack(res));
}
const getInGameItem= async (callBack) => {
    return await wax.rpc.get_table_rows({
        scope: localStorage.getItem("wax_user"),
        code: process.env.VUE_APP_CONTRACT,
        index_position: 1,
        json: true,
        limit: 1,
        table: "game.items",
        lower_bound: null
    }).then((res) => callBack(res));
}
const getBalance = async (callBack) => {
    return await axios
        .post(`${chainUrl()}/get_currency_balance`, {
            account: localStorage.getItem("wax_user"),
            code: "doublooncoin",
            symbol: "DOUB",
        }).then(callBack)
}
const getByTemplateId = async (tmpId, callback) => {
    return axios
        .get(`${process.env.VUE_APP_API_TEMPLATE_URL}/wildwestgame/${tmpId}`)
        .then((res) => callback(res))
}

const market = async (callBack, lowerBound = null) => {
    return await wax.rpc.get_table_rows({
        scope: process.env.VUE_APP_CONTRACT,
        code: process.env.VUE_APP_CONTRACT,
        index_position: 1,
        json: true,
        lower_bound: lowerBound,
        limit: 1000,
        table: process.env.VUE_APP_TBL_MARKET
    }).then(async (res) => {
        const requests = res.rows.map(async (val, index) => {
            if (val.ingame_item){
                return val
            }else{
                let nfts = await getByTemplateId(val.asset_t, (res) => res.data.data)
                res.rows[index].asset = nfts
                return val
            }
        });
        if (res.more === true) {
            await market(callBack, res.next_key);
        }
        return Promise.all(requests).then(() => {
            return res.rows
        });
    }).then((res) => callBack(res))
}
const getHealthVal = (schema)=> {
    switch (schema) {
        case "FSTEW":
            return 100;
        case "CBREAD":
            return 50;
        case "BEANS":
            return 25;
        case "JERKY":
            return 75;
        default:
            return 0;
    }
}
const getNftsBySchema = (schema,successCall)=>{
    callApiBySchema(
        `&collection_name=${process.env.VUE_APP_COLLECTION}&schema_name=${schema}`,
        (response) => {
            let res = response["data"];
            if (res["success"]) {
                successCall(res["data"]);
            } else {
                successCall(false);
            }
        }
    );
}
const getUserNfts = (schema,successCall)=>{
    callApi(
        `&collection_name=${process.env.VUE_APP_COLLECTION}&schema_name=${schema}`,
        (response) => {
            let res = response["data"];
            if (res["success"]) {
                successCall(res["data"]);
            } else {
                successCall(false);
            }
        }
    );
}
const gameItemList = ()=>{
return { 
    "GUNP":"Gun Powder",
    "FSTEW":"Frontier Stew",
    "CBREAD":"Skillet Cornbread",
    "JERKY":"Jerky",
    "BEANS":"Beans",
    "RESIN":"Tree resin",
    "METALP":"Metal Pipe",
    "IRON":"Iron",
    "ROPE":"Rope",
    "SPOON":"Spoon",
    "SAND":"Sand",
    "TIMBER":"Timber",
    "CLOTH":"Cloth",
    "PLASTIC":"Plastic",
    "ASKIN":"Alligator Skin",
    "MSPRING":"Metal Spring",
    "DYNMT":"Dynamite",
    "PISTREV":"Pistal Revolver",
    "KBINAR":"Karabinar",
    "FIRARM":"Firearm"
    };

}
const calculateCur=(price, qty)=>{
    let priceAr = price.split(" ");
    let priceSym = price.split(/(\d+)/);
    priceAr[0] = Number(priceAr[0] * qty).toFixed(priceSym[3].length);
    return priceAr.join(" ");
}
const buyDataMarket=(currency, finalPrice, templateId,qty)=>{
    if (currency) {
        return {
            contract: "eosio.token",
            action: "transfer",
            data: {
                memo: `buy:${templateId}:${qty}`,
                from: localStorage.getItem("wax_user"),
                to: process.env.VUE_APP_CONTRACT,
                quantity: finalPrice,
            },
        };
    } else {
        return {
            contract: process.env.VUE_APP_CONTRACT,
            action: "buy.item",
            data: {
                account: localStorage.getItem("wax_user"),
                qty: qty,
                asset_t: templateId
            },
        };
    }
}
const getHeaderContents = () =>{
    getInGameBalance((res) => {
        if (res.rows[0] !== undefined) {
            let bal = res.rows[0].balances;
            store.commit("addBalance", bal);
        }
    });
    getWalletBalance((res) => {
        let bal = res.data;
        store.commit("addWalletBal", bal);
    });
    getInGameItem((res) => {
        if (res.rows[0] !== undefined) {
            let item = res.rows[0].items;
            store.commit("addGameItems", item);
        }
    });
}
const getName= (item)=>{
    if (item == "Just tokens") {
        return "Token earned."
    } else if (item == "FIRARM") {
        return "Fire Arm Craft Item earned..";
    } else if (item == "PISTREV") {
        return "Pistal Revolver Craft Item earned.";
    } else if (item == "DYNMT") {
        return "Dynamite won.";
    } else {
        return gameItemNames(item);
    }
}
const gameItemNames=(item)=>{
    let gameItems = gameItemList();
    if (gameItems[item]) {
        return this.gameItems[item];
    } else {
        return item;
    }
}
export default {
    gameItemNames,
    getName,
    getHeaderContents,
    buyDataMarket,
    gameItemList,
    getUserNfts,
    getNftsBySchema,
    calculateCur,
    getInGameBalance,
    callApiBySchema,
    errorFormat,
    getHealthVal,
    errorMsg,
    market,
    successMsg,
    getBalance,
    doSign,
    isLogin,
    transaction,
    callApi,
    getTable,
    getCurrentGames,
    assetTransfer,
    signWithWax,
    getInventory,
    getImgUrl,
    getById,
    getConfig,
    setRPCUrl,
    getInGameItem,
    isExpired,
    getWalletBalance,
}